// Central site configuration — single source of truth for branding,
// contact info, images, and external links.

export const colors = {
  // Primary palette
  primary: "#3F5D4A",        // Deep sage green
  primaryDark: "#2E4537",
  sage: "#87A96B",           // Light sage accent
  terracotta: "#B8654A",     // Warm CTA accent
  terracottaDark: "#9A4F38",
  gold: "#C9A96E",           // Soft gold accent

  // Surfaces
  cream: "#F8F4ED",          // Page background
  ivory: "#FAF6EE",          // Card background / sections
  white: "#FFFFFF",

  // Text
  charcoal: "#2D2A26",
  textMuted: "#5C5852",
};

export const contact = {
  phone: "267-210-0255",
  phoneHref: "tel:2672100255",
  email: "dorseytaylorhomes@gmail.com",
  emailHref: "mailto:dorseytaylorhomes@gmail.com",
  address: {
    line1: "701 E Cathedral Road",
    line2: "Philadelphia, PA 19128",
  },
  hours: {
    weekdays: "Monday – Friday, 9 AM – 6 PM",
    saturday: "Saturday, 10 AM – 4 PM",
    sunday: "Sunday, by appointment only",
  },
};

export const social = {
  facebook: "https://Facebook.com/Dorseytaylorhomes",
  facebookHandle: "@DorseyTaylorHomes",
};

export const externalLinks = {
  applicationForm: "https://form.jotform.com/260304900526044",
  calendly: "https://calendly.com/dorseytaylorhomes",
  // Optional: set to a dedicated Jotform URL for story submissions.
  // When null, the "Submit Your Story" button routes to /contact?topic=story
  // and pre-fills the contact form.
  storySubmissionForm: null,
};

export const images = {
  logo: "https://customer-assets.emergentagent.com/job_c67525ff-89d3-4294-aae1-355dc1b1cc3a/artifacts/97gycf9q_Gmail-profile.jpg",
  heroKitchen: "https://customer-assets.emergentagent.com/job_rental-guidance/artifacts/hmzb8hco_IMG_4096.jpeg",
  heroFamily: "https://images.pexels.com/photos/5082212/pexels-photo-5082212.jpeg?auto=compress&cs=tinysrgb&w=1400",
  workshop: "https://images.pexels.com/photos/33714914/pexels-photo-33714914.jpeg?auto=compress&cs=tinysrgb&w=1400",
  workshopAudience: "https://images.pexels.com/photos/33714912/pexels-photo-33714912.jpeg?auto=compress&cs=tinysrgb&w=1400",
  // Real Dorsey Taylor Homes project photos
  projectFraming: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/k1d7uiag_IMG_5611.jpeg",
  projectStairs: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/nkjy8i7g_IMG_5613.jpeg",
  projectCelebration: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/tgljjfmg_IMG_5614.jpeg",
  projectSurvey: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/rdvla42h_IMG_5207.jpeg",
  projectFinishedKitchen: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/vwlkd0aj_IMG_5385.jpeg",
  projectFinishedOpen: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/2kyvj6xn_IMG_5620.jpeg",
  // Additional finished-bathroom photos — held for a future Project Gallery section
  projectBathTile: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/5bxf6ke0_IMG_5619.jpeg",
  projectBathModern: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/6pf5n2ik_IMG_5617.jpeg",
  projectBathBrick1: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/4d5243l4_IMG_5621.jpeg",
  projectBathBrick2: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/1wymfmmm_IMG_5622.jpeg",
  blueprints: "https://customer-assets.emergentagent.com/job_c67525ff-89d3-4294-aae1-355dc1b1cc3a/artifacts/2bt6cjco_IMG_2348.jpeg",
  teaching: "https://customer-assets.emergentagent.com/job_c67525ff-89d3-4294-aae1-355dc1b1cc3a/artifacts/crvbnqxd_IMG_2347.jpeg",
  construction1: "https://customer-assets.emergentagent.com/job_c67525ff-89d3-4294-aae1-355dc1b1cc3a/artifacts/a9srn2g0_IMG_2339.jpeg",
  construction2: "https://customer-assets.emergentagent.com/job_c67525ff-89d3-4294-aae1-355dc1b1cc3a/artifacts/apazhb8y_IMG_2340.jpeg",
  founder: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/ey9ptjon_IMG_0292.jpeg",
};

export const company = {
  name: "Dorsey Taylor Homes",
  legalName: "Dorsey Taylor Homes Inc.",
  tagline: "Affordable Housing & Education",
  mission:
    "A women-led affordable housing development company focused on community revitalization, housing stability education, and long-term pathways to homeownership.",
};

export const founder = {
  name: "Anissa Taylor",
  title: "Founder & CEO",
  photo: "https://customer-assets.emergentagent.com/job_d76a3047-d17b-461e-9556-a4b56ab743d0/artifacts/ey9ptjon_IMG_0292.jpeg",
  bio: [
    "Anissa Taylor is the founder of Dorsey Taylor Homes. Raised by a single mother who dreamed of becoming a homeowner but never had the chance, Anissa built this company around a promise: that women and families from neighborhoods like hers should have a real pathway to stable, dignified housing.",
    "Before founding Dorsey Taylor Homes in 2020, she spent 16 years as a Behavioral Therapist in the public school district and a decade as Program Director at Greater Philadelphia Health Action — work rooted in education, community, and building functional spaces for the people who needed them most. That blend of community work, behavioral science, and program building is what shapes how she develops housing today: every property is a step toward family stability, and every program is an investment in the people who will live in those homes.",
  ],
  quote:
    "A woman from the community who returned to build stability and opportunity through housing and education.",
  credentials: [
    "B.S. Behavioral Psychology, Thomas Jefferson University (Magna Cum Laude)",
    "16 years — Behavioral Therapist, Philadelphia School District",
    "President, Omega Theta Pi (Women's Social Service Org)",
    "Board Member, Re-Building Blocks",
    "Mayor's 2024 Housing, Planning & Development Sub-Committee",
  ],
};

// Categories used across Housing Stability Programs and the Resource Center.
// These will also power the category dropdown in the admin panel for resource uploads.
export const resourceCategories = [
  "Move-In Support",
  "Budgeting",
  "Rent Readiness",
  "Maintenance & Home Care",
  "Lease Literacy",
  "Homeownership Preparation",
  "Community Resources",
];

// Stories from the Community — populated as Anissa collects real testimonials
// from program participants, partner organizations, and community members.
// Each entry: { quote, name, role, location?, photo? }
export const communityStories = [
  {
    quote:
      "I can say I am no longer a homeless Vet because of Anissa and how she cares about people and their housing issues. I now live in a beautiful apartment and using some of her advice my credit is improving, I can't thank her enough.",
    name: "D. Robinson",
    role: "Veteran · Housed Through Dorsey Taylor Homes",
    location: "Veteran Housed Through Our Program",
  },
];

// Social Proof — homepage stats strip. Update these as real numbers grow.
// Set `enabled: false` on any item to temporarily hide it.
export const socialProof = [
  { value: "150+", label: "Families & Individuals Served", enabled: true },
  { value: "40", label: "Workshops Delivered", enabled: true },
  { value: "8+", label: "Partner Organizations", enabled: true },
];

// Newsletter — placeholder until Mailchimp is connected.
// When you're ready: set enabled: true, paste your Mailchimp form action URL into action,
// and update the audienceId. The footer will then show a working signup form.
export const newsletter = {
  enabled: false,
  comingSoonNote: "Coming soon — sign up to get program updates, new resources, and housing-stability tips delivered monthly.",
  action: "",           // e.g. "https://YOUR_DC.list-manage.com/subscribe/post?u=USER&id=AUDIENCE"
  audienceId: "",       // optional — populated when Mailchimp is connected
};

// Sticky top "Get Help Today" CTA bar — set enabled: false to hide it.
export const announcementBar = {
  enabled: true,
  text: "Need housing support? We are here to help.",
  ctaLabel: "Call 267-210-0255",
  ctaHref: "tel:2672100255",
  secondaryLabel: "Schedule a Consultation",
  secondaryHref: "/contact",
};

// Education sub-brand — name TBD by Anissa. Update `name` and `tagline` once decided.
// All site copy reads from here so the rename will be one edit.
export const educationProgram = {
  name: "Our Education Program", // placeholder — replace with chosen brand name
  shortName: "Education Program", // shorter version for tight UI spots
  tagline: "Where housing stability is taught.",
  description:
    "Workshops, guides, and interactive tools that teach the skills families need to stay housed and grow toward homeownership.",
  forFamiliesNote: "All resources are free to Philadelphia families and individuals.",
  forPartnersNote:
    "Contract our curriculum and live workshops for the families your organization serves.",
};

const site = {
  colors,
  contact,
  social,
  externalLinks,
  images,
  company,
  founder,
  resourceCategories,
  communityStories,
};
export default site;
